exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#artist{background:#1f1f1f}#menu .v-tabs-slider{display:none!important}", ""]);

// exports
